import { FC, useContext, useState } from "react";
import { UserContext } from "../../../../context";
import { LobbyHeaderUserProfilePicture } from "../../../organisms";
import { PinkNotification } from "../../../atoms";
import EditPen from "../../../../assets/icons/edit_pen.svg";
import { useTranslation } from "react-i18next";

const LobbyHeaderUserProfile: FC<{}> = () => {
	const { t } = useTranslation();
	const { userData, setUserData, changePlayerNickNameSocketEmit } = useContext(UserContext);
	const [newNickname, setNewNickname] = useState<string>(userData?.nickname || "");
	const [isInputShown, setIsInputShown] = useState<boolean>(false);
	const userEmail: string = userData?.email || "";

	const change = (event: any) => {
		setNewNickname(event.target.value);
	};

	const toggleInput = () => {
		setIsInputShown(!isInputShown);
	};

	const handleKeyPress = (event: any) => {
		if (event.key === "Enter")
			toggleInput();

		if (!newNickname)
			return;

		if (event.key === "Enter" && newNickname.length) {
			changePlayerNickNameSocketEmit(newNickname);
			setUserData({ ...userData, nickname: newNickname });
		
		}
	};

	const saveCurrentChange = () => {
		toggleInput();

		if (!newNickname)
			return; 

		changePlayerNickNameSocketEmit(newNickname);
		setUserData({ ...userData, nickname: newNickname });
	}

	return (
		<div className="user_mini_profile_lobby_wrapper">
			<div className="user_personal_data">
				{isInputShown ? (
					<div className="user_personal_data_text" style={{position: "relative"}}>
						<div className="full_screen" style={{ position: "absolute", top: 0}}> <PinkNotification notificationWidthVW={42} notificationRenderingSide="left" text={t("editNameInstructionsText")} /> </div>
						<input
							autoFocus
							maxLength={10}
							onBlur={saveCurrentChange}
							style={{
								height: "30px",
								position: "relative",
								width: "180px",
								border: "none",
								borderRadius: "35px",
								padding: "0 15px",
								textAlign: "center",
								background: "#003547",
								outline: "none",
								fontSize: "18px",
								lineHeight: "20px",
								zIndex: 10,
							}}
							type="text"
							value={newNickname}
							placeholder={t("editYourNameText")}
							onKeyPress={handleKeyPress}
							onChange={change}
						/>
					</div>
				) : (
					<div className="user_personal_data_text">
						<img
							className="edit_pen"
							src={EditPen}
							alt="edit pen"
							onClick={toggleInput}
						/>
						<div style={{ display: "inline-block", marginLeft: "5px" }}>{userData?.nickname}</div>
					</div>
				)}
				<div className="user_personal_data_text lobby_gray_color"> { userEmail.length < 20 ? userEmail : userEmail.substring(0, 19) + "..." } </div>
			</div>

			<LobbyHeaderUserProfilePicture />
		</div>
	);
};

export default LobbyHeaderUserProfile;
